import React, { memo } from 'react'
import { curveLinear, curveStepAfter } from '@vx/curve'
import { LinePath, AreaClosed } from '@vx/shape'

import { lineChartService } from './line-chart.service'

import { useStyles } from './line-paths.style'

const CURVES = {
  'linear': curveLinear,
  'stepAfter': curveStepAfter
}

export const LinePaths = function ({ series, scales, curve = 'linear', showPoints = true, seriesToHide = {} }) {
  const classes = useStyles()

  return series.map(({ id, name, label, points, color, bands = [] }) => {
    if (lineChartService.isSeriesHidden({ name, label }, seriesToHide)) {
      return null
    }

    return (<React.Fragment key={id}>
      { bands.map(({ points, color }, i) => {
        return (
          <AreaClosed
            key={i}
            data={points}
            x={({ x }) => scales.x(x)}
            y0={({ y0 }) => scales.y(y0)}
            y1={({ y1 }) => scales.y(y1)}
            yScale={scales.y}
            className={classes.line}
            fill={color}
            curve={CURVES[curve]}
          />
        )
      })}
      <LinePath
        data={points}
        x={({ x }) => scales.x(x)}
        y={({ y }) => scales.y(y)}
        className={classes.line}
        stroke={color}
        curve={CURVES[curve]}
      />
      { showPoints && points.map(({ x, y }) => (
        <circle key={`${x}-${y}`}
          r={4}
          fill="white"
          stroke={color}
          strokeWidth={2}
          cx={scales.x(x)}
          cy={scales.y(y)}
        />
      ))}
    </React.Fragment>)
  })
}

export const MemoizedLinePaths = memo(LinePaths)
